// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ViewUI from 'view-design';
// import 'view-design/dist/styles/iview.css';
import '@/assets/less/index.less'
import moment from 'moment'
import agent from '@/utils/agent'
import "@/utils/v-copy.js"

import { LoginBox } from '@/components/login'
Vue.prototype.$Login = LoginBox.install
Vue.prototype.$moment = moment
Vue.prototype.$agent = agent


Vue.use(ViewUI);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start();
  // 百度统计埋点
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', to.fullPath])
    }
  }
  next();
});

router.afterEach(route => {
  ViewUI.LoadingBar.finish();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js